export enum Experiments {
  SEARCH_CERTIFICATE = 'search-certificate',
  ALGOLIA_SEARCH_BAR = 'algolia-search-bar',
}
